import axios from 'axios';
import { logout } from "../store/actions/auth";
import store from '../storage';
import { getProfileStart } from '../store/actions/profile';

// Function to refresh access token using refreshToken
const refreshAccessToken = (refreshToken) => {
  return axios.post('/token/refresh/user', { refreshToken });
};

export const setInstanceAuth = (instance) => {
  instance.interceptors.request.use(function (config) {
    let token = localStorage.getItem('m-market-user-token');
    const languageCode = localStorage.getItem('i18nextLng');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Content-Type'] = 'application/json';
    }
    
    if (languageCode) {
      config.headers['Accept-Language'] = languageCode; // Add Accept-Language header
    }

    return config;
  });
}

const instance = axios.create({
  baseURL: window.globalConfig?.serverUrl || process.env.REACT_APP_SERVER_URL
});

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (accessToken) => {
  refreshSubscribers.forEach((callback) => callback(accessToken));
  refreshSubscribers = [];
};

instance.interceptors.response.use(
  async (response) => {
    if (response.status === 200 && response.data.errorCode === 108 && response.data.errorCode !== 103) {
      const refreshToken = localStorage.getItem('m-market-user-refresh-token');

      if (!isRefreshing && refreshToken) {
        isRefreshing = true;
        try {
          const refreshResponse = await refreshAccessToken(refreshToken);
          const newAccessToken = refreshResponse.data?.accessToken;
          localStorage.setItem('m-market-user-token', newAccessToken);
          onRefreshed(newAccessToken);
          isRefreshing = false;
          return instance(response.config); // Retry the original request with the new access token
        } catch (refreshError) {
          isRefreshing = false;
          store.dispatch(logout());
          return Promise.reject(refreshError);
        }
      } else {
        return new Promise((resolve) => {
          refreshSubscribers.push((accessToken) => {
            response.config.headers.Authorization = 'Bearer ' + accessToken;
            resolve(instance(response.config)); // Retry the original request with the new access token
          });
        });
      }
    } else if(response?.data?.errorCode === 103 ){
      localStorage.removeItem("m-market-user-token");
      localStorage.removeItem("m-market-user-refresh-token");
      store.dispatch(getProfileStart());
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch(logout());
    } else if(error?.response?.status === 403) {
      // service provider api integration : to handle page refresh for a while
      // window.location.reload();
    }
    return Promise.reject(error);
  }
);

setInstanceAuth(instance);

export default instance;
